<template>
    <!-- contact section -->
    <section class="section contact overflow-hidden" id="contact">
        <!-- start container -->
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-6">
                    <div class="title text-center pb-2">
                        <h6 class="mb-0 fw-bold text-primary">Contact Us</h6>
                        <h2 class="f-40">Get In Touch!</h2>
                        <p class="text-muted para-width f-15 mb-0">
                            We are happy to support your enquiries.
                        </p>
                    </div>
                </div>
            </div>

            <div class="row align-items-center">
                <div class="col-lg-5">
                    <div class="contact-box">
                        <div class="mb-4">
                            <h4 class="fw-semibold mb-1">Need Support !</h4>
                            <p class="text-muted para-width f-15">
                                * All fields are required. Phone must be numbers
                                only without leading zeros.
                            </p>
                        </div>

                        <div class="custom-form mt-4">
                            <form
                                @submit.prevent="submit"
                                method="post"
                                autocomplete="off"
                            >
                                <div
                                    v-if="error_message.length > 0"
                                    class="alert alert-warning"
                                    role="alert"
                                    v-text="error_message"
                                ></div>
                                <div
                                    v-if="success_message.length > 0"
                                    class="alert alert-success"
                                    role="alert"
                                    v-text="success_message"
                                ></div>

                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-group tw-mb-3">
                                            <label class="form-label"
                                                >{{ __("chat.name") }}
                                                <span class="tw-text-red-600"
                                                    >*</span
                                                ></label
                                            >
                                            <input
                                                v-model="form.name"
                                                type="text"
                                                class="form-control tw-py-3 tw-border-none tw-bg-slate-100 tw-rounded-lg"
                                                placeholder="Enter name"
                                                @focus="input_errors.name = ''"
                                            />
                                            <span
                                                class="tw-text-red-500 tw-text-xs"
                                                v-if="input_errors.name"
                                                v-text="input_errors.name[0]"
                                            ></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group tw-mb-3">
                                            <label class="form-label"
                                                >{{ __("chat.email_address") }}
                                                <span class="tw-text-red-600"
                                                    >*</span
                                                ></label
                                            >
                                            <input
                                                v-model="form.email"
                                                type="email"
                                                class="form-control tw-py-3 tw-border-none tw-bg-slate-100 tw-rounded-lg"
                                                placeholder="Enter email"
                                                @focus="input_errors.email = ''"
                                            />
                                            <span
                                                class="tw-text-red-500 tw-text-xs"
                                                v-if="input_errors.email"
                                                v-text="input_errors.email[0]"
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-group tw-mb-3">
                                            <label class="form-label"
                                                >{{ __("chat.phone_number") }}
                                                <span class="tw-text-red-600"
                                                    >*</span
                                                ></label
                                            >
                                            <div class="tw-relative">
                                                <input
                                                    v-model="form.phone"
                                                    type="text"
                                                    class="form-control tw-py-3 tw-border-none tw-bg-slate-100 tw-rounded-lg contact-form contact-phone-number-input"
                                                    placeholder="Enter phone"
                                                    @focus="
                                                        input_errors.phone = ''
                                                    "
                                                    @input="
                                                        form.phone =
                                                            form.phone.replace(
                                                                /\D/g,
                                                                ''
                                                            )
                                                    "
                                                />
                                                <div
                                                    class="tw-absolute tw-top-[50%] tw-translate-y-[-50%] tw-left-3 tw-text-black"
                                                >
                                                    <Select2
                                                        v-model="
                                                            form.selected_country_code
                                                        "
                                                        :options="
                                                            $page.props
                                                                .all_country_dial_codes
                                                                .codes
                                                        "
                                                        :settings="{
                                                            templateSelection:
                                                                selectedFormat,
                                                        }"
                                                        @change="
                                                            myChangeEvent(
                                                                $event
                                                            )
                                                        "
                                                        @select="
                                                            mySelectEvent(
                                                                $event
                                                            )
                                                        "
                                                        id="contactPhoneInput"
                                                    />
                                                </div>
                                            </div>
                                            <span
                                                class="tw-text-red-500 tw-text-xs"
                                                v-if="input_errors.phone"
                                                v-text="input_errors.phone[0]"
                                            ></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group tw-mb-3">
                                            <label
                                                for="exampleFormControlInput1"
                                                class="form-label"
                                                >{{ __("chat.contact_type") }}
                                                <span class="tw-text-red-600"
                                                    >*</span
                                                ></label
                                            >
                                            <select
                                                v-model="
                                                    form.contact_message_type_id
                                                "
                                                class="form-select tw-py-3 tw-border-none tw-bg-slate-100 tw-rounded-lg"
                                                @change="
                                                    input_errors.contact_message_type_id =
                                                        ''
                                                "
                                            >
                                                <option value="">
                                                    Please choose
                                                </option>
                                                <option
                                                    :value="
                                                        each.contact_message_type_id
                                                    "
                                                    :key="key"
                                                    v-for="(each, key) in $page
                                                        .props
                                                        .contact_message_types"
                                                >
                                                    {{
                                                        each.contact_message_type_name
                                                    }}
                                                </option>
                                            </select>
                                            <span
                                                class="tw-text-red-500 tw-text-xs"
                                                v-if="
                                                    input_errors.contact_message_type_id
                                                "
                                                v-text="
                                                    input_errors
                                                        .contact_message_type_id[0]
                                                "
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="form-group tw-mb-3">
                                            <label class="form-label"
                                                >{{ __("chat.subject") }}
                                                <span class="tw-text-red-600"
                                                    >*</span
                                                ></label
                                            >
                                            <input
                                                v-model="form.subject"
                                                type="text"
                                                class="form-control tw-py-3 tw-border-none tw-bg-slate-100 tw-rounded-lg"
                                                placeholder="Enter subject"
                                                @focus="
                                                    input_errors.subject = ''
                                                "
                                            />
                                            <span
                                                class="tw-text-red-500 tw-text-xs"
                                                v-if="input_errors.subject"
                                                v-text="input_errors.subject[0]"
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="form-group tw-mb-3">
                                            <label class="form-label"
                                                >{{ __("chat.message_label") }}
                                                <span class="tw-text-red-600"
                                                    >*</span
                                                ></label
                                            >
                                            <textarea
                                                v-model="form.message"
                                                rows="4"
                                                class="form-control tw-py-3 tw-border-none tw-bg-slate-100 tw-rounded-lg"
                                                placeholder="Enter message"
                                                @focus="
                                                    input_errors.message = ''
                                                "
                                            ></textarea>
                                            <span
                                                class="tw-text-red-500 tw-text-xs"
                                                v-if="input_errors.message"
                                                v-text="input_errors.message[0]"
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 tw-mb-5">
                                        <vue-recaptcha
                                            :key="recaptchaComponentKey"
                                            @verify="onCaptchaVerify"
                                            :sitekey="
                                                $page.props.recaptchav2_sitekey
                                            "
                                        />
                                        <span
                                            v-if="recaptcha_error"
                                            class="tw-text-red-500 tw-text-xs"
                                        >
                                            {{
                                                translate(
                                                    "Please confirm you are not a robot.",
                                                    "သင်ကိုယ်တိုင်ဖြစ်ကြောင်း အတည်ပြုပါ။"
                                                )
                                            }}
                                        </span>
                                    </div>
                                </div>
                                <div class="row my-2">
                                    <div class="col-lg-12 d-grid">
                                        <button
                                            @click.prevent="submit"
                                            class="btn tw-h-[45px] tw-w-full btn-md tw-rounded-md tw-text-white tw-bg-main-color"
                                        >
                                            <BeatLoader
                                                v-if="submitting"
                                                :loading="submitting"
                                                color="white"
                                                size="7px"
                                                class="tw-pt-[3px]"
                                            ></BeatLoader>
                                            <span v-else>{{
                                                __("chat.send")
                                            }}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="m-5">
                        <div class="position-relative">
                            <div class="contact-map">
                                <img
                                    class="tw-w-full tw-rounded-lg"
                                    :src="require('@asset/landing/img/map.png')"
                                />
                            </div>
                            <div class="map-shape"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mt-4 pt-2">
                    <div class="text-center">
                        <i class="mdi mdi-google-maps f-40 text-primary"></i>
                        <h6 class="mb-1">Location</h6>
                        <p class="f-14 mb-0 text-muted">
                            1 NORTH BRIDGE ROAD, 11-06 HIGH STREET CENTRE,
                            Singapore, 179094
                        </p>
                    </div>
                </div>
                <div class="col-md-4 mt-4 pt-2">
                    <div class="text-center">
                        <i class="mdi mdi-email f-40 text-primary"></i>
                        <h6 class="mb-1">Email</h6>
                        <p class="f-14 mb-0 text-muted">
                            <a
                                class="text-muted hover:tw-underline"
                                href="mailto:info@titi.chat"
                                >info@titi.chat</a
                            >
                        </p>
                    </div>
                </div>
                <div class="col-md-4 mt-4 pt-2">
                    <div class="text-center">
                        <i class="mdi mdi-phone f-40 text-primary"></i>
                        <h6 class="mb-1">Phone</h6>
                        <p class="f-14 mb-0 text-muted">
                            <a
                                class="text-muted hover:tw-underline"
                                href="tel:+6594395466"
                                >+65 94395466</a
                            >
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- end container -->
    </section>
    <!-- end section -->
</template>
<script>
import BeatLoader from "vue-spinner/src/BeatLoader.vue";
import { VueRecaptcha } from "vue-recaptcha";

export default {
    components: { BeatLoader, VueRecaptcha },
    data() {
        return {
            input_errors: {},
            error_message: "",
            success_message: "",
            submitting: false,
            recaptcha_error: false,
            recaptchaComponentKey: 1,
            form: {
                name: "",
                email: "",
                phone: "",
                contact_message_type_id: "",
                selected_country_code: "",
                selected_dial_code: "",
                subject: "",
                message: "",
            },
        };
    },
    mounted() {
        this.form.selected_country_code =
            this.$page.props.all_country_dial_codes.current.country_code;
        this.form.selected_dial_code =
            this.$page.props.all_country_dial_codes.current.dial_code;

        this.select2InputStyle(this.form.selected_dial_code);
    },
    methods: {
        onCaptchaVerify(token) {
            // Provide the token response to the form object.
            this.form["g-recaptcha-response"] = token;
            this.recaptcha_error = false;
        },
        selectedFormat() {
            return this.form.selected_dial_code;
        },
        myChangeEvent(val) {
            this.select2InputStyle(val);
        },
        mySelectEvent({ id, text }) {
            const regex = /\((\+\d+)\)/;
            const match = text.match(regex);
            if (match && match.length > 1) {
                this.form.selected_dial_code = match[1];
            }

            this.select2InputStyle(this.form.selected_dial_code);
        },
        select2InputStyle(val) {
            var canvas = document.createElement("canvas");
            var context = canvas.getContext("2d");
            context.font = "15px Arial";
            var metrics = context.measureText(val);
            let input = document.querySelector(".contact-phone-number-input");
            input.style.paddingLeft = Math.ceil(metrics.width) + 18 + "px";
        },
        submit() {
            this.submitting = true;
            if (!this.form["g-recaptcha-response"]) {
                // Show error after submit.
                this.recaptcha_error = true;
                setTimeout(() => {
                    this.submitting = false;
                }, 500);
            } else {
                axios
                    .post(
                        `${process.env.MIX_APP_URL}/contact-message/store`,
                        this.form
                    )
                    .then(({ data }) => {
                        if (data.result == 1) {
                            this.error_message = "";
                            this.input_errors = {};
                            this.success_message = data.message;
                            this.form = {
                                name: "",
                                email: "",
                                phone: "",
                                contact_message_type_id: "",
                                subject: "",
                                message: "",
                            };

                            this.recaptchaComponentKey += 1;
                            this.submitting = false;
                        } else {
                            this.input_errors = {};
                            this.success_message = "";
                            this.error_message = data.message;
                        }
                    })
                    .catch((error) => {
                        if (error.response && error.response.status == 422) {
                            this.success_message = "";
                            this.error_message = "";
                            this.input_errors = error.response.data.errors;
                        } else {
                            this.input_errors = {};
                            this.error_message = this.__(
                                "chat.something_wrong"
                            );
                            this.success_message = "";
                        }
                        setTimeout(() => {
                            this.submitting = false;
                        }, 500);
                    });
            }
        },
    },
};
</script>
